enum FundHistoricPriceIntervalType {
  CURRENTYEAR = 'CurrentYear',
  MONTHS1 = 'Months1',
  MONTHS6 = 'Months6',
  YEARS1 = 'Years1',
  YEARS3 = 'Years3',
  YEARS5 = 'Years5',
}

export default FundHistoricPriceIntervalType;
